<div class="job-fulfillment-type-selector">
    <div *ngIf="!editMode; else editing">
        <span>{{viewModeText}}</span>
        <button *ngIf="canEdit && !editMode" class="edit-button" mat-icon-button color="primary"
            (click)="onEditClicked()">
            <mat-icon>edit</mat-icon>
        </button>
    </div>
    <ng-template #editing>
        <div class="select-container">
            <div class="multi-select">
                <mat-form-field appearance="outline">
                    <mat-select [formControl]="selectedTypesControl" (selectionChange)="selectionsChangedEvent()" multiple>
                        <mat-select-trigger
                            class="job-fulfillment-type-selector-trigger">{{selectionsTriggerText}}</mat-select-trigger>
                        <mat-option *ngFor="let type of availableTypes" [value]="type.id"
                            [disabled]="type.id === JobFulfillmentTypeEnum.DefaultWorkflow"
                            class="job-fulfillment-type-selector-option">
                            <div class="job-fulfillment-type-selector-option-content">
                                <span>{{type.name}}</span>
                                <mat-icon [novaMultiLineTooltip]="type.info">info</mat-icon>
                            </div>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <span class="nova__label">Default Fulfillment</span>
            <div class="default-select">
                <mat-form-field appearance="outline">
                    <mat-select [formControl]="defaultTypeControl" (selectionChange)="defaultSelectionChangedEvent()">
                        <mat-select-trigger
                            class="job-fulfillment-type-selector-trigger">{{defaultTriggerText}}</mat-select-trigger>
                        <mat-option *ngFor="let type of availableDefaultTypes" [value]="type.id"
                            class="job-fulfillment-type-selector-option">
                            <div class="job-fulfillment-type-selector-option-content">
                                <span>{{type.name}}</span>
                                <mat-icon [novaMultiLineTooltip]="type.info">info</mat-icon>
                            </div>
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="defaultTypeControl.hasError('required')">You must make a
                        selection</mat-error>
                </mat-form-field>
            </div>
            <div class="edit-buttons-container">
                <button class="edit-button" [disabled]="saveButtonDisabled" mat-icon-button color="primary"
                    (click)="saveChanges()">
                    <mat-icon>check_circle</mat-icon>
                </button>
                <button class="edit-button" mat-icon-button color="primary" (click)="cancelEditMode()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>
    </ng-template>
</div>